import { Link } from 'react-router-dom';

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/" aria-label="QuizPiko home">
      <img src={compact ? '/brand/quizpiko-icon.png' : '/brand/quizpiko-logo.png'} alt="QuizPiko" />
    </Link>
  );
}


